<icms-outlet class="w-12"
             [name]="'500page'">
</icms-outlet>
